module.exports = __webpack_public_path__ + "static/media/background.295d75d0.png";